import { useMemo } from 'react'
import { cn } from '@segway/core'

export interface SkeletonProps extends React.ButtonHTMLAttributes<HTMLDivElement> {
  block?: boolean
  height?: number
  shape?: 'circle' | 'round' | 'square'
}

/**
 * 骨架屏幕
 */
const Skeleton = ({ className, block = true, shape = 'square', ...props }: SkeletonProps) => {
  const shapeStyle = useMemo(() => {
    if (shape === 'circle') {
      return 'rounded-full'
    }

    if (shape === 'round') {
      return 'rounded-xl'
    }

    return ''
  }, [shape])

  return (
    <div
      className={cn('h-[10rem] bg-gray-0', { 'w-full': block }, shapeStyle, className)}
      {...props}></div>
  )
}

Skeleton.displayName = 'Skeleton'

export default Skeleton
